import React, { useState } from 'react';
import BrushAndZoomComponent from '../../../Views/component/BrushAndZoomComponent';
import { controlPiezoList, getDataMeasures, getDataTresholds, loaderForGraphics } from './detailsHelper';
import { piezoPluvioInterface } from '../../../Views/H2SParam/Interface';
import { LocalStorage } from '../../localStorage';
import { HttpArcgis } from '../../http';
import { PiezometryApi } from '../../api';
import { app_placeholder } from '../../../env.placeholders';

// create a button for pompe to show or hide on the graphic
export const AddPompesButton = (props: any) => {
  return (
    <button
      style={{
        backgroundColor: props.buttonColor,
        height: '40px',
        width: 'auto',
        borderRadius: '10px',
        margin: '5px',
        fontWeight: 'bold',
        padding: '10px'
      }}
      onClick={props.onClick}
      name={props.name}
      id={props.id}
    >
      {props.name}
    </button>
  );
};

// hide or show pompes
export const updateColors = (
  pId: string,
  pColorHisto: string[],
  pButtonColors: string[],
  pColorsStore: string[]
) => {
  const copyOfColors = [...pColorHisto];
  const copyOfButtonColors = [...pButtonColors];
  if (copyOfColors[pId] === 'transparent') {
    copyOfColors[pId] = pColorsStore[pId];
    copyOfButtonColors[pId] = pColorsStore[pId];
  } else {
    copyOfColors[pId] = 'transparent';
    copyOfButtonColors[pId] = '#E5E7E9';
  }
  return {
    newColorsHisto: copyOfColors,
    newButtonColors: copyOfButtonColors,
  };
};

export const createConfigPompesButtons = (props: any, colorsStore: string[]) => {
  // define how many buttons to create for pompes
  const prTemps = props.data.allMeasures?.prTemps || [];
  const prNombre = props.data.allMeasures?.prNombre || [];
  const dataToCreateColors = prTemps.concat(prNombre);
  
  if (dataToCreateColors.length === 0) {
    return [];
  }
  
  // get the names of pompes
  const getPompesNames = Array.from(
    new Map(dataToCreateColors.map(item => [item.variableName.slice(2), item])).values()
  ).map((item: any) => item.variableName.slice(2));
  
  const configPompesButtons = getPompesNames.map((name, index) => {
    return { color: colorsStore[index], name };
  });
  return configPompesButtons;
}

export const getColorsForHisto = (configPompesButtons: any[], colorsHisto: string[], prData: any[]) => {
  // Create a mapping of variable names to colors
  const colorMap = new Map();
  configPompesButtons.forEach((button, index) => {
    // Match button name with variable name (button.name is variableName.slice(2))
    const matchingVariable = prData.find(
      (p) => p.variableName.endsWith(button.name)
    );
    if (matchingVariable) {
      colorMap.set(matchingVariable.variableName, colorsHisto[index]);
    }
  });
  
  // Return colors in the same order as prTemps data
  return prData.map((item) => {
    return colorMap.get(item.variableName);
  });
}

export const PrMrGraphicsContainer = (props) => {
  const typeData = props.code?.includes('PR') ? 'PR' : 'MR';
  const titleTempGraphic = 'Temps de pompage sur le ' + typeData;
  const titleNumberGraphic =
    'Nombre de démarrage des pompes sur le ' + typeData;
  const titleVolumeGraphic = 'Volume relevé du ' + typeData;
  const colorsStore = ['#D98880', '#138D75', '#F8C471', '#BB8FCE', '#F7DC6F', '#85C1E9', '#A569BD', '#F1948A'];
  let configPompesButtons: any[] = [];

  // create buttons for pompes
  if(props.data.allMeasures !== null) {
    configPompesButtons = createConfigPompesButtons(props, colorsStore);
  }

  const [colorsHisto, setColorsHisto] = useState<string[]>(colorsStore);
  const [buttonColors, setButtonColors] = useState<string[]>(colorsStore);
  const [zoomDomainTemp, setZoomDomainTemp] = useState<any>({
    x: [new Date(1990, 1, 1), new Date(2009, 1, 1)],
  });
  const [zoomDomainNumber, setZoomDomainNumber] = useState<any>({
    x: [new Date(1990, 1, 1), new Date(2009, 1, 1)],
  });
  const [showhidePompesButtons, setDisplayPompesButtons] =
    useState<boolean>(true);

  const handleButtonColors = (pId: string) => {
    const newColors = updateColors(pId, colorsHisto, buttonColors, colorsStore);
    setColorsHisto(newColors.newColorsHisto);
    setButtonColors(newColors.newButtonColors);
  };

  // handler of zooming
  const handleZoomContainer = (domain) => {
    domain !== undefined &&
      setZoomDomainTemp({ ...zoomDomainTemp, x: domain.x });
    domain !== undefined &&
      setZoomDomainNumber({ ...zoomDomainNumber, x: domain.x });
  };

  const handleDisplayPompesButtons = () => {
    if(showhidePompesButtons === true){
      setDisplayPompesButtons(false);
    } else {
      setDisplayPompesButtons(true);
    }
  };

  const piezoDataChecked = (props.data.piezoMeasures !== null && props.data.piezoMeasures.length > 0) 
    ? controlPiezoList(props.data.piezoMeasures, props.piezoCode) 
    : [];

  const loaderPiezo = () => {
    return (
      <div>
        <span className="loaderPiezo"/>
      </div>
    );
  };  

  return (
    <>
      <div style={{ display: 'inline-flex' }}>
        {showhidePompesButtons === true && props.data.allMeasures !== null && configPompesButtons.length !== 0 && configPompesButtons.map((p, key) => {
            return (
              <div key={key}>
                <AddPompesButton
                  id={key}
                  name={p.name}
                  buttonColor={buttonColors[key]}
                  onClick={(d) => {
                    handleButtonColors(d.target.id);
                  }}
                />
              </div>
            );
          })}
        {showhidePompesButtons === true && props.data.allMeasures === null && loaderPiezo()}
      </div>
      <div style={{ display: 'inline-flex' }}>
        {/* temp graphic */}
        <div style={{ marginRight: '10px'}}>
          {props.data.allMeasures !== null ? 
            <BrushAndZoomComponent
              data={props.data.allMeasures.prTemps}
              title={titleTempGraphic}
              automatedTestId='dataTemps-chart'
              pluvioData={props.data.allMeasures.pluvioList}
              dataSelected={props.dataSelected}
              piezoData={piezoDataChecked}
              tresholdsDataList={props.data.allMeasures.prTemps}
              axisXLabel='Date'
              axisYLabel='Temps (h)'
              axisYLabelPluvio='Quantité (mm)'
              showHide={props.showHide['dataTemps-chart']}
              handleShowHide={props.handleShowHideGraphics}
              legend={[
                {
                  name: 'Pluviométrie',
                  symbol: { fill: '#85C1E9' },
                  show: true,
                },
                {
                  name: 'Piézomètre',
                  symbol: { fill: '#9400D3' },
                  show: true,
                },
              ]}
              colorsForPompes={getColorsForHisto(configPompesButtons, colorsHisto, props.data.allMeasures.prTemps)}
              mode='multiple'
              zoomMode='synchro'
              typeOfGraphic='bar'
              handleZoomContainer={handleZoomContainer}
              zoomDomain={zoomDomainTemp}
          /> : loaderForGraphics('74vh', '55vh', 'loaderPrMrGraphics')}
        </div>
        {/* number graphic */}
        <div style={{ marginLeft: '10px' }}>
          {props.data.allMeasures !== null ? 
            <BrushAndZoomComponent
              data={props.data.allMeasures.prNombre}
              title={titleNumberGraphic}
              automatedTestId='dataNombre-chart'
              pluvioData={props.data.allMeasures.pluvioList}
              dataSelected={props.dataSelected}
              piezoData={piezoDataChecked}
              tresholdsDataList={props.data.allMeasures.prNombre}
              axisXLabel='Date'
              axisYLabel='Nombre'
              showHide={props.showHide['dataNombre-chart']}
              handleShowHide={props.handleShowHideGraphics}
              legend={[
                {
                  name: 'Pluviométrie',
                  symbol: { fill: '#85C1E9' },
                  show: true,
                },
                {
                  name: 'Piézomètre',
                  symbol: { fill: '#9400D3' },
                  show: true,
                },
              ]}
              colorsForPompes={getColorsForHisto(configPompesButtons, colorsHisto, props.data.allMeasures.prNombre)}
              mode='multiple'
              zoomMode='synchro'
              typeOfGraphic='bar'
              handleZoomContainer={handleZoomContainer}
              zoomDomain={zoomDomainNumber}
          /> : loaderForGraphics('74vh', '55vh', 'loaderPrMrGraphics')}
        </div>
      </div>
      {/* volume graphics */}
      <div style={{ display: 'inline-flex', marginBottom: '10px' }}>
        <div style={{ marginTop: '10px' }}>
          {props.data.allMeasures !== null ?
            <BrushAndZoomComponent
              data={getDataMeasures(typeData, 'volume', props.data.allMeasures)}
              tresholdsDataList={getDataTresholds(
                typeData,
                'volume',
                props.data.allMeasures
              )}
              pluvioData={props.data.allMeasures !== null ? props.data.allMeasures.pluvioList : []}
              dataSelected={props.dataSelected}
              piezoData={piezoDataChecked}
              title={titleVolumeGraphic}
              automatedTestId='dataVolume-chart'
              axisXLabel='Date'
              axisYLabel='Volume (m³)'
              axisYLabelPluvio='Quantité (mm)'
              showHide={props.showHide['dataVolume-chart']}
              handleShowHide={props.handleShowHideGraphics}
              legend={[
                {
                  name: 'Volume',
                  symbol: { fill: '#85929E' },
                  show: true,
                },
                {
                  name: 'Pluviométrie',
                  symbol: { fill: '#85C1E9' },
                  show: true,
                },
                {
                  name: 'Piézomètre',
                  symbol: { fill: '#9400D3' },
                  show: true,
                },
                {
                  name: 'Seuil min',
                  symbol: { fill: '#FF0000' },
                  show: false,
                },
                {
                  name: 'Seuil max',
                  symbol: { fill: '#FF0000' },
                  show: false,
                },
              ]}
              mode='solo'
              zoomMode='alone'
              typeOfGraphic='bar'
              colorsForPompes={colorsHisto}
              handleDisplayPompesButtons={handleDisplayPompesButtons}
            />
            : loaderForGraphics('74vh', '55vh', 'loaderPrMrGraphics')}
        </div>
      {/* PR levels */}
        <div style={{ marginLeft: '20px', marginTop: '10px' }}>
          {props.data.allMeasuresLevelsPr !== null ?
            <BrushAndZoomComponent
              data={getDataMeasures(typeData, 'levels', props.data.allMeasuresLevelsPr)}
              tresholdsDataList={getDataTresholds(
                typeData,
                'levels',
                props.data.allMeasuresLevelsPr
              )}
              pluvioData={props.data.allMeasures !== null ? props.data.allMeasures.pluvioList : []}
              dataSelected={props.dataSelected}
              piezoData={piezoDataChecked}
              title={'Niveaux d\'eau du PR'}
              automatedTestId='dataLevels-chart'
              axisXLabel='Date'
              axisYLabel='Hauteur (m)'
              axisYLabelPluvio='Quantité (mm)'
              showHide={props.showHide['dataLevels-chart']}
              handleShowHide={props.handleShowHideGraphics}
              legend={[
                {
                  name: 'Niveau maxi',
                  symbol: { fill: '#0072B2' },
                  show: true,
                },
                {
                  name: 'Niveau moyen',
                  symbol: { fill: '#A6611A' },
                  show: true,
                },
                {
                  name: 'Niveau mini',
                  symbol: { fill: '#009E73' },
                  show: true,
                },
                {
                  name: 'Pluviométrie',
                  symbol: { fill: '#85C1E9' },
                  show: true,
                },
                {
                  name: 'Piézomètre',
                  symbol: { fill: '#9400D3' },
                  show: true,
                },
                {
                  name: 'Seuil d\'alerte',
                  symbol: { fill: '#FF0000' },
                  show: true,
                },
                {
                  name: 'Seuil de vigilance',
                  symbol: { fill: '#FFA500' },
                  show: true,
                },
              ]}
              mode='multiple'
              zoomMode='alone'
              typeOfGraphic='line'
              handleDisplayPompesButtons={handleDisplayPompesButtons}
            /> : loaderForGraphics('74vh', '55vh', 'loaderPrMrGraphics')}
        </div>
      </div>
    </>
  );
};

export const verifyPluvioAndPiezoData = (pPLuvioList: any[], pPiezoList: any[]) => {
    let interfaceValues: any[] = [];
    let showHideFilters = false;
    // param interafaceValues
    if(pPLuvioList.length > 0){
      interfaceValues.push(piezoPluvioInterface.filter((p) => p.id === 1)[0]);
    }
    if(pPiezoList.length > 0){
      interfaceValues.push(piezoPluvioInterface.filter((p) => p.id === 2)[0]);
    }
    // show or hide filters
    if(interfaceValues.length > 0){
      interfaceValues.push(piezoPluvioInterface.filter((p) => p.id === 3)[0]);
      showHideFilters = true;
    }
    return {
      interfaceValues: interfaceValues,
      showHideFilters: showHideFilters
    }
  };

export const getPiezoIds = async (code: string | null) => {
  const formBody: string[] = [];
  formBody.push("where=Code in ('"+code+"')");
  formBody.push('outFields=Distance,Code,WaterTableStationCode');
  formBody.push('orderByFields=Distance');
  formBody.push('resultRecordCount=5');
  formBody.push('returnGeometry=false');
  formBody.push('f=json');
  formBody.push('user=' + LocalStorage.userMail.get());
  const formBodyToSend = formBody.join('&');
  let datas: any;

  try {
    const responseSections = await HttpArcgis.post(
      app_placeholder.VITE_APP_ARCGIS_SERVER + '?path=/57/query',
      JSON.stringify(formBodyToSend)
    );
    if (
      responseSections.status === 200 &&
      responseSections.data.features !== undefined
    ) {
      datas = responseSections.data.features;
    } else {
      console.log('Aucune données !');
      datas = [];
    }
    return datas;
  } catch (error) {
    console.log('Failed to get data for table !', error);
    return [];
  }
};

export const getPiezoParameter = async (code: string | null) => {
  try {
    const response = await PiezometryApi.getParameter(code);
    if (response.status === 200) {
      return response.data;
    } else {
      console.log('Aucune données !');
      return undefined;
    }
  } catch (error) {
    console.log('Failed to get piezo parameter data !', error);
    return undefined;
  }
};
